import { MetricUId } from "../../Metrics/constants"
import getChartConfigTemplate from "../Templates/PieChart/utils"
import { mergeProps } from "../../../generic/Utils/mergeProps";

const metricColorMap = {
  [MetricUId.INACTIVE_GROUPS_COUNT]: "#E54D2E",
  [MetricUId.ACTIVE_GROUPS_COUNT]: "#0969DA",
  [MetricUId.NOT_STARTED_GROUPS_COUNT]: "#F76B15"
}

export const chartOnlyMetrics = [MetricUId.ACTIVE_GROUPS_COUNT, MetricUId.INACTIVE_GROUPS_COUNT, MetricUId.NOT_STARTED_GROUPS_COUNT, MetricUId.TOTAL_ONGOING_GROUPS_COUNT]

const getChartConfig = function(props = {}) {
  const mergedProps = mergeProps(props, {
    seriesMetricsUids: [MetricUId.ACTIVE_GROUPS_COUNT, MetricUId.INACTIVE_GROUPS_COUNT, MetricUId.NOT_STARTED_GROUPS_COUNT],
    subTitleMetricUid: MetricUId.TOTAL_ONGOING_GROUPS_COUNT,
    exportFileName: props.name,
    tooltip: props.tooltip,
    metricColorMap: metricColorMap
  });

  return getChartConfigTemplate(mergedProps);
};

export default getChartConfig;
